module.exports = __webpack_public_path__ + "static/media/integral1.png";